<script>
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'
import AtualizarVagasEmMassa from './AtualizarVagasEmMassa'
import ScanEmMassa from './ScanEmMassa'
import RetiradaEmMassa from './RetiradaEmMassa'
import LotesLeilaoEmMassa from './LotesLeilaoEmMassa'

const AUTOMACOES = [
  {
    codigo: 'vagas-patio',
    label: 'Atualizar vagas/pátio em massa',
    descricao: 'Envie uma planilha para trocar o pátio e/ou a vaga de várias GRVs de uma vez.',
    component: 'AtualizarVagasEmMassa',
    acl: 'atualizar_vagas_grv_em_massa'
  },
  {
    codigo: 'scan',
    label: 'Adicionar scan em massa',
    descricao: 'Vincule um único PDF de scan a várias GRVs de uma vez, a partir de uma planilha.',
    component: 'ScanEmMassa',
    acl: 'atualizar_vagas_grv_em_massa'
  },
  {
    codigo: 'retirada',
    label: 'Corrigir dados de retirada em massa',
    descricao: 'Corrija nome, documento, CEP e endereço já cadastrados na retirada de várias GRVs.',
    component: 'RetiradaEmMassa',
    acl: 'atualizar_vagas_grv_em_massa'
  },
  {
    codigo: 'lotes-leilao',
    label: 'Atualizar lotes de leilão (roubo/furto) em massa',
    descricao: 'Atualiza número, valores e status de vários lotes de um mesmo leilão a partir de uma planilha. Específico para leilões de veículos de roubo/furto.',
    component: 'LotesLeilaoEmMassa',
    acl: 'atualizar_vagas_grv_em_massa'
  }
]

export default {
  name: 'Automacoes',
  mixins: [AclCheckMixins],
  components: {
    AtualizarVagasEmMassa,
    ScanEmMassa,
    RetiradaEmMassa,
    LotesLeilaoEmMassa
  },
  data () {
    return {
      selecionada: null
    }
  },
  computed: {
    automacoes () {
      return AUTOMACOES.filter(a => this.possuiACL(a.acl))
    },
    automacaoAtual () {
      return this.automacoes.find(a => a.codigo === this.selecionada) || null
    }
  },
  methods: {
    limpar () {
      this.selecionada = null
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">Automações</h1>
                  <small class="text-muted">
                    Operações em massa sobre GRVs a partir de planilha.
                  </small>
                </div>
              </div>
            </div>

            <div class="panel panel-default" v-if="automacoes.length">
              <div class="wrapper">
                <div class="form-group">
                  <label>O que você quer fazer?</label>
                  <select class="form-control" v-model="selecionada" style="max-width: 480px">
                    <option :value="null" disabled>Selecione uma automação...</option>
                    <option v-for="automacao in automacoes" :key="automacao.codigo" :value="automacao.codigo">
                      {{ automacao.label }}
                    </option>
                  </select>
                  <p class="text-muted m-t-xs" v-if="automacaoAtual">{{ automacaoAtual.descricao }}</p>
                </div>
              </div>

              <div class="b-t" v-if="automacaoAtual">
                <component
                  :is="automacaoAtual.component"
                  :key="automacaoAtual.codigo"
                  @close="limpar"
                  @finishSubmit="() => {}"
                ></component>
              </div>
            </div>

            <div class="panel panel-default wrapper-md text-muted" v-else>
              Você não tem permissão para nenhuma automação no momento.
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// Automacoes.vue?ecc44844